export default {"src":"/_next/static/image/public/images/ic_pencil_blue.09d4dd9f03c25a4bd87dcbde0ffef100.svg","height":20,"width":20};